import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Escaneas tu Despensa SOS',
    desc: 'Configuras tus suministros para eliminar la toma de decisiones al cocinar.'
  }, {
    num: '2',
    title: 'Activas la Sincronización',
    desc: 'Aplicas los micro-movimientos mientras preparas la cena.'
  }, {
    num: '3',
    title: 'Cierras la Tienda',
    desc: 'Ejecutas el ritual de 5 minutos antes de dormir para garantizar un mañana sin estrés.'
  }];
  return <section className="py-24 bg-linen" data-id="element-45">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-46">
        <FadeIn data-id="element-47">
          <h2 className="text-4xl md:text-5xl text-center text-charcoal mb-16" data-id="element-48">
            Cómo funciona
          </h2>

          <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-49">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-terracotta/20 -z-10" data-id="element-50"></div>

            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative" data-id="element-51">
                <div className="flex flex-col items-center text-center" data-id="element-52">
                  <div className="w-24 h-24 rounded-full bg-white shadow-warm flex items-center justify-center text-3xl font-serif text-terracotta mb-6 border-4 border-linen" data-id="element-53">
                    {step.num}
                  </div>
                  <h3 className="text-2xl font-serif text-charcoal mb-4" data-id="element-54">
                    {step.title}
                  </h3>
                  <p className="text-warmgray leading-relaxed" data-id="element-55">{step.desc}</p>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}